
import { IIsiDtoPlInstanceFormResult, IIsiDtoPlInstanceScreenRequest, IsiDtoPlInstanceFormResult, IsiDtoPlInstanceScreenRequest, IsiDtoPlInstanceScreenResponse, IsiDtoPlInstanceScreenResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlInstanceScreen";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";
export interface IIsiDtoNbDroitModifAssoc {
    nbInstance: number,
    instanceCode: string
}

export class IsiPlInstanceScreen extends IsiPresentationLogic {

    constructor() {
        super("IsiPlInstanceScreenHandler");
    }


    private readonly _nok = "NOK";
    private readonly _parc001Code = "PARC001";
    private readonly _GetNbAllVTStr = "GetNbAllVT";
    private readonly _GetNbDroitVTStr = "GetNbDroitVT";
    private readonly _GetVTInstanceStr = "GetVTInstance";
    private readonly _GetNbDroitModifStr = "GetNbDroitModif";
    private readonly _GetNbDroitStr = "GetNbDroit";
    private readonly _GetInstanceStr = "GetInstance";
    private readonly _GetNbDroitModifAssocStr = "GetNbDroitModifAssoc";


    /*-----------------------------------------------------------
    Renvoie la response construite par _getResponseByTreatment 
    ----------------------------------------------------------*/
    private async _callAjax(dto: IIsiDtoPlInstanceScreenRequest, ajaxTreatment: string): Promise<IsiDtoPlInstanceScreenResponse> {
        return new Promise<IsiDtoPlInstanceScreenResponse>((resolve, reject) => {

            let responseByTreatment = this._getResponseByTreatment(ajaxTreatment);

            let getInstances = IsiDtoPlInstanceScreenRequest.fromJS({
                codeEcranListe:dto.codeEcranListe,
                codeEcran: dto.codeEcran,
                nbInstVTAllCount: dto.nbInstVTAllCount,
                nbInstanceVTAddCount: dto.nbInstanceVTAddCount,
                listInstanceVTAdd: dto.listInstanceVTAdd,
                listDroitModif: dto.listDroitModif,
                controlId: dto.controlId,
                response: responseByTreatment
            });

            this.ajax(ajaxTreatment, getInstances, true).then(
                (request: IsiDtoPlInstanceScreenRequest) => {
                    resolve(request.response);
                }
            ).catch((data: IsiDtoPlInstanceScreenResponse) => {
                reject(data);
            });
        });
    }

    /*-----------------------------------------------------------
  Renvoie la response selon le Traitement Ajax
  ----------------------------------------------------------*/
    private _getResponseByTreatment(ajaxTreatment: string) {
        switch (ajaxTreatment) {
            case this._GetNbAllVTStr:
                return IsiDtoPlInstanceScreenResponse.fromJS({
                    getNbAllVTResult: IsiDtoPlInstanceScreenResult.fromJS({})
                })
            case this._GetNbDroitVTStr:
                return IsiDtoPlInstanceScreenResponse.fromJS({
                    getNbDroitVTResult: IsiDtoPlInstanceScreenResult.fromJS({})
                })
            case this._GetVTInstanceStr:
                return IsiDtoPlInstanceScreenResponse.fromJS({
                    getVTInstanceResult: IsiDtoPlInstanceScreenResult.fromJS({})
                })
            case this._GetNbDroitModifStr:
                return IsiDtoPlInstanceScreenResponse.fromJS({
                    getNbDroitModifResult: IsiDtoPlInstanceScreenResult.fromJS({})
                })
            case this._GetNbDroitStr:
                return IsiDtoPlInstanceScreenResponse.fromJS({
                    getNbDroitResult: IsiDtoPlInstanceScreenResult.fromJS({})
                })
            case this._GetInstanceStr:
                return IsiDtoPlInstanceScreenResponse.fromJS({
                    getInstanceFormulaire: IsiDtoPlInstanceFormResult.fromJS({})
                })
            case this._GetNbDroitModifAssocStr:
                return IsiDtoPlInstanceScreenResponse.fromJS({
                    getNbDroitModifResult: IsiDtoPlInstanceScreenResult.fromJS({})
                })

        }
    }

    /**
     * Renvoie le nombre d'instance VT par sa réponse.
     * */
    GetNbAllVT(): Promise<IIsiUIFlowResultGeneric<number>> {
        const dto: IIsiDtoPlInstanceScreenRequest = new IsiDtoPlInstanceScreenRequest;
        dto.codeEcran = this._parc001Code;
        return new Promise<IIsiUIFlowResultGeneric<number>>((resolve, reject) => {
            this._callAjax(dto, this._GetNbAllVTStr).then((getInstances) => {
                resolve({
                    result: getInstances.getNbAllVTResult.instanceScreenResult !== this._nok,
                    continue: true,
                    reponse: getInstances.getNbAllVTValue
                });
            });
        });
    }

    /**
     * Renvoie le nombre d'instance VT où l'utilisateur a des droits.
     * */
    GetNbDroitVT(): Promise<IIsiUIFlowResultGeneric<number>> {
        const dto: IIsiDtoPlInstanceScreenRequest = new IsiDtoPlInstanceScreenRequest;
        dto.codeEcran = this._parc001Code;
        return new Promise<IIsiUIFlowResultGeneric<number>>((resolve, reject) => {
            this._callAjax(dto, this._GetNbDroitVTStr).then((getInstances) => {
                resolve({
                    result: getInstances.getNbDroitVTResult.instanceScreenResult !== this._nok,
                    continue: true,
                    reponse: getInstances.getNbDroitVTValue
                });
            });
        });
    }

    /**
     * Renvoie le code écran correspondant à une instance VT.
     * */
    GetVTInstance(): Promise<IIsiUIFlowResultGeneric<string>> {
        const dto: IIsiDtoPlInstanceScreenRequest = new IsiDtoPlInstanceScreenRequest;
        dto.codeEcran = this._parc001Code;
        return new Promise<IIsiUIFlowResultGeneric<string>>((resolve, reject) => {
            this._callAjax(dto, this._GetVTInstanceStr).then((getInstances) => {
                resolve({
                    result: getInstances.getVTInstanceResult.instanceScreenResult !== this._nok,
                    continue: true,
                    reponse: getInstances.getVTInstanceValue
                });
            });
        });
    }

    /**
     * Renvoie le nombre d'instance où l'utilisateur a des droits de modif.
     * */
    GetNbDroitModif(screenListCode: string, screenCode: string): Promise<IIsiUIFlowResultGeneric<number>> {
        return new Promise<IIsiUIFlowResultGeneric<number>>((resolve, reject) => {
            const dto: IIsiDtoPlInstanceScreenRequest = new IsiDtoPlInstanceScreenRequest;
            dto.codeEcran = screenCode;
            dto.codeEcranListe = screenListCode;
            this._callAjax(dto, this._GetNbDroitModifStr).then((getInstances) => {
                resolve({
                    result: getInstances.getNbDroitModifResult.instanceScreenResult !== this._nok,
                    continue: true,
                    reponse: getInstances.getNbDroitModifValue
                });
            });
        });
    }
    /**
    * Renvoie le nombre d'instance où l'utilisateur a des droits de modif. Selon le filtre de l'association si une seule instance renvoi aussi le code 
    * */
    GetNbDroitModifAssoc(screenListCode: string, screenCode: string): Promise<IIsiUIFlowResultGeneric<IIsiDtoNbDroitModifAssoc>> {
        return new Promise<IIsiUIFlowResultGeneric<IIsiDtoNbDroitModifAssoc>>((resolve, reject) => {
            const dto: IIsiDtoPlInstanceScreenRequest = new IsiDtoPlInstanceScreenRequest;
            dto.codeEcran = screenCode;
            dto.codeEcranListe = screenListCode;
            this._callAjax(dto, this._GetNbDroitModifAssocStr).then((getInstances) => {
                resolve({
                    result: getInstances.getNbDroitModifResult.instanceScreenResult !== this._nok,
                    continue: true,
                    reponse: {
                        instanceCode : getInstances.getNbDroitModifResult.instanceScreenResult,
                        nbInstance: getInstances.getNbDroitModifValue
                    } 
                });
            });
        });
    }

    /**
     * Renvoie le nombre d'instance où l'utilisateur a des droit d'ajout selon l'écran et le control
     * */
    GetNbDroit(screenCode: string, controlId: string): Promise<IIsiUIFlowResultGeneric<number>> {
        return new Promise<IIsiUIFlowResultGeneric<number>>((resolve, reject) => {
            const dto: IIsiDtoPlInstanceScreenRequest = new IsiDtoPlInstanceScreenRequest;
            dto.codeEcran = screenCode;
            dto.controlId = controlId;
            this._callAjax(dto, this._GetNbDroitStr).then((getInstances) => {
                resolve({
                    result: getInstances.getNbDroitResult.instanceScreenResult !== this._nok,
                    continue: true,
                    reponse: getInstances.getNbDroitValue
                });
            });
        });
    }

    /**
     * Renvoie le nombre d'instance où l'utilisateur a des droit d'ajout selon l'écran et le control
     * */
    async GetInstance(currentScreenCode: string, controlId: string, evaluatedString: string): Promise<IIsiUIFlowResultGeneric<IIsiDtoPlInstanceFormResult>> {
        const params = IsiDtoPlInstanceScreenRequest.fromJS({
            codeEcran: currentScreenCode,
            controlId: controlId,
            evaluatedValue: evaluatedString,
            response: IsiDtoPlInstanceScreenResponse.fromJS({
            })
        });

        const result: IIsiUIFlowResultGeneric<IsiDtoPlInstanceScreenRequest> = await this.ajaxWithErrorHandling(this._GetInstanceStr, params, false);
        const objResult: IIsiUIFlowResultGeneric<IIsiDtoPlInstanceFormResult> = {
            result: result.reponse.response.success,
            continue: true,
            reponse: {
                moreOneInstance: result.reponse.response.getInstanceFormulaire.moreOneInstance,
                instanceFormResult: result.reponse.response.getInstanceFormulaire.instanceFormResult
            }
        }

        return objResult;

    }
}